import InfoMessageWithSeeExample from './InfoMessageWithSeeExample';
export default InfoMessageWithSeeExample;

export { type InfoMessageWithSeeExampleProps } from './InfoMessageWithSeeExample';
